import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["variant", "title", "children", "variantIconAriaLabel"];
import { jsx, jsxs } from 'react/jsx-runtime';
import { AlertTriangle, InfoBadge, CheckmarkBadge, AlertBadge } from '@box/blueprint-web-assets/icons/Line';
import { useMemo } from 'react';
import { BaseInlineNotice } from '../primitives/base-inline-notice/index.js';

var getBackgroundColorByVariant = function getBackgroundColorByVariant(variant) {
  switch (variant) {
    case 'error':
      return 'backgroundRed';

    case 'success':
      return 'backgroundGreen';

    case 'warning':
      return 'backgroundYellow';

    case 'info':
    default:
      return 'backgroundBlue';
  }
};

var getInlineNoticeIcon = function getInlineNoticeIcon(variant) {
  switch (variant) {
    case 'error':
      return AlertBadge;

    case 'success':
      return CheckmarkBadge;

    case 'info':
      return InfoBadge;

    case 'warning':
      return AlertTriangle;

    default:
      return null;
  }
};
/**
 * A component used to highlight some portion of the text.
 */


function InlineNotice(props) {
  var variant = props.variant,
      title = props.title,
      children = props.children,
      variantIconAriaLabel = props.variantIconAriaLabel,
      rest = _objectWithoutProperties(props, _excluded);

  var iconComponent = useMemo(function () {
    return getInlineNoticeIcon(variant);
  }, [variant]);
  return jsx(BaseInlineNotice, _objectSpread(_objectSpread({}, rest), {}, {
    backgroundColor: getBackgroundColorByVariant(variant),
    children: jsxs(BaseInlineNotice.ContentContainer, {
      children: [jsx(BaseInlineNotice.Icon, {
        icon: iconComponent,
        iconAriaLabel: variantIconAriaLabel
      }), jsxs(BaseInlineNotice.Content, {
        children: [title && jsx(BaseInlineNotice.Content.Title, {
          children: title
        }), jsx(BaseInlineNotice.Content.Body, {
          children: children
        })]
      })]
    })
  }));
}

export { InlineNotice };